import { render, staticRenderFns } from "./PersistResponsavelFilialView.vue?vue&type=template&id=6671707e&"
import script from "./PersistResponsavelFilialView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelFilialView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports